export const BOOKING_CONFIRMATION_PAGE_META = [
  { name: 'hotels-booking-stage', content: 'booking-confirmation' },
  { name: 'robots', content: 'noindex, follow' },
  { name: 'description', content: 'Booking Confirmation | Qantas Hotels Australia' },
];
